export default __webpack_public_path__ + "static/media/circle.8c897a3d.svg";